// // import './styles.css';

// // import { Color } from '@tiptap/extension-color';
// // import ListItem from '@tiptap/extension-list-item';
// // import TextStyle from '@tiptap/extension-text-style';
// // import { EditorProvider, useCurrentEditor } from '@tiptap/react';
// // import StarterKit from '@tiptap/starter-kit';
// // import React from 'react';
// // import Link from './Link';
// import { LinkPopover } from './LinkPopover';
// import React from 'react';
// import { EditorProvider, EditorContent, useCurrentEditor } from '@tiptap/react';
// import StarterKit from '@tiptap/starter-kit';
// import Link from '@tiptap/extension-link';
// import TextStyle from '@tiptap/extension-text-style';
// import {
//     Bold,
//     Italic,
//     Strikethrough,
//     Code,
//     Heading1,
//     Heading2,
//     Heading3,
//     List,
//     ListOrdered,
//     Quote,
//     Minus,
//     Undo,
//     Redo,
//     Link as LinkIcon,
//     Type,
//     AlignLeft,
// } from 'lucide-react';

// const MenuBar = () => {
//     const { editor } = useCurrentEditor();

//     if (!editor) {
//         return null;
//     }

//     console.log(
//         editor.getJSON(),
//         editor.getText(),
//         editor.getHTML(),

//         editor.isActive('bold'),
//         'check here for everything'
//     );

//     const buttonClass = `
//     inline-flex items-center justify-center
//     w-9 h-9 rounded-md
//     text-gray-700 hover:text-blue-600
//     bg-grayBgNormal hover:bg-blue-50
//     border border-gray-200 hover:border-blue-300
//     transition-all duration-200 ease-in-out
//     focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1
//     disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-grayBgNormal disabled:hover:text-gray-700 disabled:hover:border-gray-200
//   `;

//     const activeButtonClass = `

//         inline-flex items-center justify-center
//     w-9 h-9 rounded-md

//      hover:bg-blue-50
//     border
//     transition-all duration-200 ease-in-out
//     focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1
//     disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-grayBgNormal disabled:hover:text-gray-700 disabled:hover:border-gray-200

//     bg-blue-600 text-white border-blue-600
//     hover:bg-blue-700 hover:border-blue-700 hover:text-white
//   `;
//     const separatorClass = 'w-px h-6 bg-gray-300 mx-1';
//     return (
//         <div className="sticky top-0 z-10 bg-grayBgNormal shadow-sm">
//             <div className="">
//                 <div className="flex flex-wrap items-center gap-1 p-3 bg-gray-50 border-b border-gray-200 rounded-t-lg">
//                     {/* Text Formatting */}
//                     <button
//                         type="button"
//                         onClick={() => editor.chain().focus().toggleBold().run()}
//                         disabled={!editor.can().chain().focus().toggleBold().run()}
//                         className={`  ${editor.isActive('bold') ? activeButtonClass : buttonClass}`}
//                         title="Bold (Ctrl+B)"
//                     >
//                         <Bold size={16} />
//                     </button>

//                     <button
//                         type="button"
//                         onClick={() => editor.chain().focus().toggleItalic().run()}
//                         disabled={!editor.can().chain().focus().toggleItalic().run()}
//                         className={` ${editor.isActive('italic') ? activeButtonClass : buttonClass}`}
//                         title="Italic (Ctrl+I)"
//                     >
//                         <Italic size={16} />
//                     </button>

//                     <button
//                         type="button"
//                         onClick={() => editor.chain().focus().toggleStrike().run()}
//                         disabled={!editor.can().chain().focus().toggleStrike().run()}
//                         className={` ${editor.isActive('strike') ? activeButtonClass : buttonClass}`}
//                         title="Strikethrough"
//                     >
//                         <Strikethrough size={16} />
//                     </button>

//                     {/* <button
//                     type="button"
//                     onClick={() => editor.chain().focus().toggleCode().run()}
//                     disabled={!editor.can().chain().focus().toggleCode().run()}
//                     className={` ${editor.isActive('code') ? activeButtonClass : buttonClass}`}
//                     title="Inline Code"
//                 >
//                     <Code size={16} />
//                 </button> */}

//                     <div className={separatorClass} />

//                     {/* Headings */}
//                     {/* <button
//                     type="button"
//                     onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
//                     className={` ${editor.isActive('heading', { level: 1 }) ? activeButtonClass : buttonClass}`}
//                     title="Heading 1"
//                 >
//                     <Heading1 size={16} />
//                 </button> */}

//                     {/* <button
//                     type="button"
//                     onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
//                     className={` ${editor.isActive('heading', { level: 2 }) ? activeButtonClass : buttonClass}`}
//                     title="Heading 2"
//                 >
//                     <Heading2 size={16} />
//                 </button> */}

//                     {/* <button
//                     type="button"
//                     onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
//                     className={` ${editor.isActive('heading', { level: 3 }) ? activeButtonClass : buttonClass}`}
//                     title="Heading 3"
//                 >
//                     <Heading3 size={16} />
//                 </button> */}

//                     {/* <button
//                     type="button"
//                     onClick={() => editor.chain().focus().setParagraph().run()}
//                     className={` ${editor.isActive('paragraph') ? activeButtonClass : buttonClass}`}
//                     title="Paragraph"
//                 >
//                     <AlignLeft size={16} />
//                 </button> */}

//                     {/* Lists */}
//                     {/* <button
//                     type="button"
//                     onClick={() => editor.chain().focus().toggleBulletList().run()}
//                     className={` ${editor.isActive('bulletList') ? activeButtonClass : buttonClass}`}
//                     title="Bullet List"
//                 >
//                     <List size={16} />
//                 </button> */}

//                     {/* <button
//                     type="button"
//                     onClick={() => editor.chain().focus().toggleOrderedList().run()}
//                     className={` ${editor.isActive('orderedList') ? activeButtonClass : buttonClass}`}
//                     title="Numbered List"
//                 >
//                     <ListOrdered size={16} />
//                 </button> */}

//                     {/* Block Elements */}
//                     {/* <button
//                     type="button"
//                     onClick={() => editor.chain().focus().toggleBlockquote().run()}
//                     className={` ${editor.isActive('blockquote') ? activeButtonClass : buttonClass}`}
//                     title="Blockquote"
//                 >
//                     <Quote size={16} />
//                 </button> */}

//                     <LinkPopover editor={editor} />

//                     {/* <button
//                     type="button"
//                     onClick={() => editor.chain().focus().setHorizontalRule().run()}
//                     className={buttonClass}
//                     title="Horizontal Rule"
//                 >
//                     <Minus size={16} />
//                 </button> */}

//                     <div className={separatorClass} />

//                     {/* Link */}

//                     {/* Utility Actions */}
//                     <button
//                         type="button"
//                         onClick={() => editor.chain().focus().unsetAllMarks().run()}
//                         className={buttonClass}
//                         title="Clear Formatting"
//                     >
//                         <Type size={16} />
//                     </button>

//                     <div className={separatorClass} />

//                     {/* Undo/Redo */}
//                     <button
//                         type="button"
//                         onClick={() => editor.chain().focus().undo().run()}
//                         disabled={!editor.can().chain().focus().undo().run()}
//                         className={buttonClass}
//                         title="Undo (Ctrl+Z)"
//                     >
//                         <Undo size={16} />
//                     </button>

//                     <button
//                         type="button"
//                         onClick={() => editor.chain().focus().redo().run()}
//                         disabled={!editor.can().chain().focus().redo().run()}
//                         className={buttonClass}
//                         title="Redo (Ctrl+Y)"
//                     >
//                         <Redo size={16} />
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// // const extensions = [
// //     Color.configure({ types: [TextStyle.name, ListItem.name] }),
// //     TextStyle.configure({ types: [ListItem.name] }),
// //     Link.configure({ openOnClick: false }),
// //     StarterKit.configure({
// //         bulletList: {
// //             keepMarks: true,
// //             keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
// //         },
// //         orderedList: {
// //             keepMarks: true,
// //             keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
// //         },
// //     }),
// // ];

// // const content = `
// // <h2>
// //   Hi there,
// // </h2>
// // <p>
// //   this is a <em>basic</em> example of <strong>Tiptap</strong>. Sure, there are all kind of basic text styles you’d probably expect from a text editor. But wait until you see the lists:
// // </p>
// // <ul>
// //   <li>
// //     That’s a bullet list with one …
// //   </li>
// //   <li>
// //     … or two list items.
// //   </li>
// // </ul>
// // <p>
// //   Isn’t that great? And all of that is editable. But wait, there’s more. Let’s try a code block:
// // </p>
// // <pre><code class="language-css">body {
// //   display: none;
// // }</code></pre>
// // <p>
// //   I know, I know, this is impressive. It’s only the tip of the iceberg though. Give it a try and click a little bit around. Don’t forget to check the other examples too.
// // </p>
// // <blockquote>
// //   Wow, that’s amazing. Good work, boy! 👏
// //   <br />
// //   — Mom
// // </blockquote>
// // `;

// // export default function TipTapEditor() {
// //     return <EditorProvider slotBefore={<MenuBar />} extensions={extensions} content={content}></EditorProvider>;
// // }

// export default function TipTapEditor({ content = '', onChange, className = '' }) {
//     const extensions = [
//         StarterKit,
//         Link.configure({
//             openOnClick: false,
//             HTMLAttributes: {
//                 class: 'text-blue-600 hover:text-blue-800 underline cursor-pointer',
//             },
//         }),
//         TextStyle,
//     ];

//     const editorProps = {
//         attributes: {
//             class: 'prose prose-sm sm:prose-base lg:prose-lg xl:prose-2xl mx-auto focus:outline-none min-h-[200px] p-4',
//         },
//     };

//     return (
//         <div
//             className={`border   border-gray-300 rounded-lg h-80 overflow-y-auto main bg-grayBgNormal shadow-sm ${className}`}
//         >
//             <EditorProvider
//                 slotBefore={<MenuBar />}
//                 extensions={extensions}
//                 content={content}
//                 onUpdate={({ editor }) => {
//                     if (onChange) {
//                         onChange(editor.getHTML());
//                     }
//                 }}
//                 editorProps={editorProps}
//             >
//                 <div className="">
//                     <EditorContent className=" h-full " />
//                 </div>
//             </EditorProvider>
//         </div>
//     );
// }

import { EditorProvider, EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import TextStyle from '@tiptap/extension-text-style';
import CharacterCount from '@tiptap/extension-character-count';
import Placeholder from '@tiptap/extension-placeholder';

import React from 'react';
import { useCurrentEditor } from '@tiptap/react';
import {
    Bold,
    Italic,
    Strikethrough,
    Code,
    Heading1,
    Heading2,
    Heading3,
    List,
    ListOrdered,
    Quote,
    Minus,
    Undo,
    Redo,
    Link as LinkIcon,
    Type,
    AlignLeft,
    Underline,
} from 'lucide-react';
import { LinkPopover } from './LinkPopover';
import CharacterLimit from '../../ui/CharacterLimit';

function extractLinkedWordsByWordIndex(json) {
    const result = [];
    let wordIndex = 0;

    // Only count alphabetic word-like tokens; ignore punctuation like `.`, `,`
    const tokenizeWordsOnly = (text) => {
        return text.match(/\b\w+\b/g) || [];
    };

    const walkNodes = (nodes) => {
        for (const node of nodes) {
            if (node.type === 'text') {
                const tokens = tokenizeWordsOnly(node.text);
                const linkMark = node.marks?.find((mark) => mark.type === 'link');

                if (linkMark) {
                    result.push({
                        startIndex: wordIndex,
                        endIndex: wordIndex + tokens.length - 1,
                        link: linkMark.attrs.href,
                    });
                }

                wordIndex += tokens.length;
            }

            if (node.content) {
                walkNodes(node.content);
            }
        }
    };

    walkNodes(json.content);
    return result;
}

export const MenuBar = ({ editor }) => {
    if (!editor) {
        return null;
    }

    const buttonClass = `
    inline-flex items-center justify-center
    w-8 h-8 rounded-md
    text-textSecondary hover:text-textPrimary
    bg-grayBgNormal hover:bg-grayBgDark
    border border-borderUnderline
    transition-all duration-150 ease-in-out
    focus:outline-none focus:ring-2 focus:ring-blueNormal focus:ring-offset-0
    disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-grayBgNormal disabled:hover:text-textSecondary
  `;

    const activeButtonClass = `
    bg-blueNormal text-hardLight border border-blueNormal
    hover:bg-blueNormalHover hover:border-blueNormalHover
    shadow-sm
  `;

    const tooltipClass = `
    absolute top-full left-1/2 transform -translate-x-1/2 mt-2
    px-2 py-1 text-xs text-white bg-gray-800 rounded-md
    opacity-0 group-hover:opacity-100 transition-opacity duration-200
    pointer-events-none whitespace-nowrap z-[9999]
    before:content-[''] before:absolute before:bottom-full before:left-1/2 before:transform before:-translate-x-1/2
    before:border-4 before:border-transparent before:border-b-gray-800
  `;

    const separatorClass = 'w-px h-5 bg-gray-300 mx-2';

    console.log(editor?.getJSON(), editor.getText(), editor.isEmpty, editor.getHTML(), 'see the editor');

    return (
        <div className="sticky top-0 z-10 bg-grayBgNormal">
            <div className="flex items-center gap-1 p-3 bg-grayBgNormal border-b border-borderUnderline rounded-t-lg shadow-sm overflow-visible">
                {/* Undo/Redo */}
                <button
                    type="button"
                    onClick={() => editor.chain().focus().undo().run()}
                    disabled={!editor.can().chain().focus().undo().run()}
                    className={buttonClass}
                    title="Undo (Ctrl+Z)"
                >
                    <Undo size={14} />
                </button>

                <button
                    type="button"
                    onClick={() => editor.chain().focus().redo().run()}
                    disabled={!editor.can().chain().focus().redo().run()}
                    className={buttonClass}
                    title="Redo (Ctrl+Y)"
                >
                    <Redo size={14} />
                </button>

                <div className={separatorClass} />

                {/* Headings Dropdown Style */}
                {/* <div className="relative">
                <select
                    value={
                        editor.isActive('heading', { level: 1 })
                            ? 'h1'
                            : editor.isActive('heading', { level: 2 })
                            ? 'h2'
                            : editor.isActive('heading', { level: 3 })
                            ? 'h3'
                            : 'p'
                    }
                    onChange={(e) => {
                        const value = e.target.value;
                        if (value === 'p') {
                            editor.chain().focus().setParagraph().run();
                        } else {
                            const level = parseInt(value.replace('h', ''));
                            editor.chain().focus().toggleHeading({ level }).run();
                        }
                    }}
                    className="appearance-none bg-grayBgNormal border-0 text-sm text-gray-700 pr-6 pl-2 py-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer"
                >
                    <option value="p">Normal</option>
                    <option value="h1">Heading 1</option>
                    <option value="h2">Heading 2</option>
                    <option value="h3">Heading 3</option>
                </select>

                <div className="absolute right-1 top-1/2 transform -translate-y-1/2 pointer-events-none">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path
                            d="M3 4.5L6 7.5L9 4.5"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div> */}
                <LinkPopover editor={editor} />

                {/* Lists */}
                {/* <button
                type="button"
                onClick={() => editor.chain().focus().toggleBulletList().run()}
                className={`${buttonClass} ${editor.isActive('bulletList') ? activeButtonClass : ''}`}
                title="Bullet List"
            >
                <List size={14} />
            </button> */}

                {/* <button
                type="button"
                onClick={() => editor.chain().focus().toggleOrderedList().run()}
                className={`${buttonClass} ${editor.isActive('orderedList') ? activeButtonClass : ''}`}
                title="Numbered List"
            >
                <ListOrdered size={14} />
            </button> */}

                {/* Code Block */}
                {/* <button
                type="button"
                onClick={() => editor.chain().focus().toggleCodeBlock().run()}
                className={`${buttonClass} ${editor.isActive('codeBlock') ? activeButtonClass : ''}`}
                title="Code Block"
            >
                <Code size={14} />
            </button> */}

                {/* Text Formatting */}
                {/* <button
                type="button"
                onClick={() => editor.chain().focus().toggleBold().run()}
                disabled={!editor.can().chain().focus().toggleBold().run()}
                className={`${buttonClass} ${editor.isActive('bold') ? activeButtonClass : ''}`}
                title="Bold (Ctrl+B)"
            >
                <Bold size={14} />
            </button> */}

                {/* <button
                type="button"
                onClick={() => editor.chain().focus().toggleItalic().run()}
                disabled={!editor.can().chain().focus().toggleItalic().run()}
                className={`${buttonClass} ${editor.isActive('italic') ? activeButtonClass : ''}`}
                title="Italic (Ctrl+I)"
            >
                <Italic size={14} />
            </button> */}

                {/* <button
                type="button"
                onClick={() => editor.chain().focus().toggleStrike().run()}
                disabled={!editor.can().chain().focus().toggleStrike().run()}
                className={`${buttonClass} ${editor.isActive('strike') ? activeButtonClass : ''}`}
                title="Strikethrough"
            >
                <Strikethrough size={14} />
            </button> */}

                {/* <button
                type="button"
                onClick={() => editor.chain().focus().toggleCode().run()}
                disabled={!editor.can().chain().focus().toggleCode().run()}
                className={`${buttonClass} ${editor.isActive('code') ? activeButtonClass : ''}`}
                title="Inline Code"
            >
                <Code size={14} />
            </button> */}

                {/* <button
                type="button"
                onClick={() => {
                    // Toggle underline using text-decoration
                    const isActive = editor.getAttributes('textStyle')?.textDecoration === 'underline';
                    if (isActive) {
                        editor.chain().focus().unsetMark('textStyle').run();
                    } else {
                        editor.chain().focus().setMark('textStyle', { textDecoration: 'underline' }).run();
                    }
                }}
                className={`${buttonClass} ${
                    editor.getAttributes('textStyle')?.textDecoration === 'underline' ? activeButtonClass : ''
                }`}
                title="Underline"
            >
                <Underline size={14} />
            </button> */}

                {/* Link */}

                <div className={separatorClass} />

                {/* Utility Actions */}
                <button
                    type="button"
                    onClick={() => editor.chain().focus().unsetAllMarks().run()}
                    className={buttonClass}
                    title="Clear Formatting"
                >
                    <Type size={14} />
                </button>
            </div>
        </div>
    );
};
function TiptapEditor({ content = '', onChange, handleDescriptionLinkPayload, className = '' }) {
    const editor = useEditor({
        extensions: [
            StarterKit,
            Link.configure({
                openOnClick: false,
                HTMLAttributes: {
                    class: 'text-blue-600 hover:text-blue-800 underline cursor-pointer',
                },
            }),
            TextStyle,
            CharacterCount.configure({
                limit: 1000,
            }),
            Placeholder.configure({
                placeholder: 'Please provide a short description',
                emptyEditorClass: 'text-textSecondary',
            }),
        ],
        content,
        onUpdate: ({ editor }) => {
            console.log(
                editor.getText(),
                editor?.getHTML(),
                editor?.getJSON(),
                extractLinkedWordsByWordIndex(editor.getJSON()),

                'inside on upate'
            );
            if (!editor.getText()) {
                onChange('');
            } else {
                onChange(editor.getHTML());
                handleDescriptionLinkPayload(extractLinkedWordsByWordIndex(editor.getJSON()));
            }
        },
        editorProps: {
            attributes: {
                class: 'prose prose-sm sm:prose-base lg:prose-lg xl:prose-2xl mx-auto focus:outline-none min-h-[200px] p-4 bg-grayBgNormal text-textPrimary rounded-b-lg',
            },
        },
    });
    // const { editor } = useCurrentEditor(); // access editor via context
    // const extensions = [
    //     StarterKit,
    //     Link.configure({
    //         openOnClick: false,
    //         HTMLAttributes: {
    //             class: 'text-blue-600 hover:text-blue-800 underline cursor-pointer',
    //         },
    //     }),
    //     CharacterCount.configure({
    //         limit: 1000,
    //     }),
    //     TextStyle,
    // ];

    // const editorProps = {
    //     attributes: {
    //         class: 'prose prose-sm sm:prose-base lg:prose-lg xl:prose-2xl mx-auto focus:outline-none min-h-[200px] p-4',
    //     },
    // };

    console.log(editor?.getJSON(), editor, editor.storage.characterCount.characters(), 'real editor state');
    return (
        <div className="">
            <div
                className={`border border-borderUnderline overflow-hidden rounded-lg bg-grayBgNormal shadow-sm focus-within:border-blueNormal focus-within:ring-0 focus-within:ring-blueNormal ${className}`}
            >
                {/* <EditorProvider
                slotBefore={<MenuBar />}
                extensions={extensions}
                content={content}
                onUpdate={({ editor }) => {
                    if (onChange) {
                        onChange(editor.getHTML());
                    }
                }}
                editorProps={editorProps}
            >
                <div className="">
                    <EditorContent className=" " />
                </div>
            </EditorProvider> */}

                <MenuBar editor={editor} />
                <EditorContent editor={editor} className="h-52 main overflow-auto px-4 py-3" />
            </div>

            <div className="flex items-center justify-between mt-1">
                <p className="text-xs text-textSecondary">Highlight text to add links</p>
                {/* Character limit uses plain text length */}
                <CharacterLimit min={editor.storage.characterCount.characters()} max={1000} />
            </div>
        </div>
    );
}

export default TiptapEditor;
